<section class="admin-section" data-test="role-map-editor">
  <h2 class="admin-h2">Staff role mapping</h2>
  <p class="admin-lede">Which TM roles each Orbit role gives. Tick several to give several roles, or none for no TM access. An Orbit user whose roles map to no TM role gets no TM account. Admin is given by hand in TM, so it is not offered here.</p>

  <div class="tw:my-2 tw:p-3 tw:border tw:border-sky-500 tw:bg-sky-50 tw:text-sky-900 tw:rounded" data-test="role-map-banner">
    Changes apply on the next staff sync.
  </div>

  @if (error) {
    <div class="tw:my-2 tw:p-3 tw:border tw:border-red-500 tw:bg-red-50 tw:text-red-900 tw:rounded" data-test="role-map-error">{{error}}</div>
  }

  @if (loading) {
    <p>Loading…</p>
  }

  @if (!loading && orbitUnreachable) {
    <div class="tw:my-2 tw:p-3 tw:border tw:border-amber-500 tw:bg-amber-50 tw:text-amber-900 tw:rounded" data-test="role-map-orbit-unreachable">
      Orbit could not be reached, so only the saved mappings are listed. New or removed Orbit roles cannot be shown.
    </div>
  }

  @if (!loading && roles.length > 0) {
    <div class="tw:overflow-x-auto">
      <table class="admin-table">
        <thead>
          <tr>
            <th class="tw:text-left">Orbit role</th>
            <th class="tw:text-left tw:w-96">TM roles</th>
            <th class="tw:text-left tw:w-56">Last changed</th>
            <th class="tw:text-left tw:w-40"></th>
          </tr>
        </thead>
        <tbody>
          @for (role of roles; track role.orbitRoleName) {
            <tr data-test="role-map-row">
              <td>
                <strong>{{role.orbitRoleName}}</strong>
                @if (isNewInOrbit(role)) {
                  <span class="tw:ml-2 tw:rounded tw:px-1 tw:text-xs tw:font-semibold tw:bg-amber-100 tw:text-amber-900" data-test="badge-new">New in Orbit (unmapped)</span>
                }
                @if (isGoneFromOrbit(role)) {
                  <span class="tw:ml-2 tw:rounded tw:px-1 tw:text-xs tw:font-semibold tw:bg-gray-200 tw:text-gray-800" data-test="badge-gone">No longer in Orbit</span>
                }
              </td>
              <td data-label="TM roles">
                <div data-test="role-map-codes">{{describe(savedCodes(role))}}</div>
                @if (unmappableCodes(role).length > 0) {
                  <div class="tw:text-sm tw:text-amber-900" data-test="role-map-unmappable">
                    {{describe(unmappableCodes(role))}} is given by hand in TM, not by the staff sync. Saving this row removes it from the mapping.
                  </div>
                }
                <div class="tw:flex tw:flex-wrap tw:gap-x-4 tw:mt-1">
                  @for (leap of mappableRoles; track leap.code) {
                    <label class="field__checkbox" data-test="role-map-option">
                      <input type="checkbox" [attr.data-code]="leap.code" [checked]="isSelected(role, leap.code)"
                        [disabled]="saving === role.orbitRoleName" (change)="toggle(role, leap.code)" />
                      {{leap.description}} ({{leap.code}})
                    </label>
                  }
                </div>
              </td>
              <td data-label="Last changed">
                @if (role.lastChangedUtc) {
                  <admin-email [value]="role.lastChangedBy || 'unknown'" /><br />
                  <span class="tw:text-sm tw:opacity-75">{{role.lastChangedUtc | date:'dd/MM/yyyy HH:mm'}}</span>
                } @else {
                  <span class="tw:text-sm tw:opacity-50">Never changed</span>
                }
              </td>
              <td>
                <button type="button" class="btn" [disabled]="!isDirty(role) || saving === role.orbitRoleName" (click)="save(role)" data-test="role-map-save">Save</button>
                <button type="button" class="btn" (click)="history(role)" data-test="role-map-history">History</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!loading && !error && roles.length === 0) {
    <p class="tw:opacity-60" data-test="role-map-empty">No Orbit roles to map.</p>
  }
</section>
